
<div class="flow-application-card" :tabindex="tabindex" @click="handleClick($event)">
	<div class="flow-application-card-content">
		<div class="display-flex j-c-space-bet align-items-start">
			<h4 class="fc-dark text-ellipsis">
				{{ name }}
			</h4>
			<Icon
				name="info-2"
				type="filled"
				state="light"
				size="small"
				:effects="false"
				@click="handleInfoClick($event)"
			/>
		</div>
		<p class="paragraph-2 fc-light margin-bt-16">
			{{ status }}
		</p>
		<div class="display-flex align-items-center">
			<Icon
				:name="iconNames.commit"
				state="white"
				size="x-small"
				:effects="false"
				type="filled"
				class="margin-rt-4"
			/>
			<p class="paragraph-2 fc-light text-ellipsis">
				{{ commit }}
			</p>
		</div>
		<div class="display-flex align-items-center">
			<Icon
				:name="iconNames.branch"
				state="white"
				size="x-small"
				:effects="false"
				type="filled"
				class="margin-rt-4"
			/>
			<p class="paragraph-2 fc-light text-ellipsis">
				{{ branch }}
			</p>
		</div>
	</div>
	<div class="flow-application-card-footer">
		<slot name="footer" />
	</div>
</div>
